var _style, _text, _text2, _text3, _text4, _text5, _g, _text6, _text7, _text8, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polyline, _polyline2, _path9, _polyline3, _path10, _g2, _line, _line2, _line3, _polygon, _line4, _polyline4, _line5, _path11, _line6, _polygon2, _rect, _line7, _polyline5, _path12, _line8, _line9, _line10, _line11, _line12, _polygon3, _line13, _polygon4, _line14, _text9, _circle, _text10, _text11, _text12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFig2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 570 800",
    viewBox: "0 0 570 800",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{font-family:'BodoniMT-Italic';}\n\t.st2{font-size:37.2013px;}\n\t.st3{font-family:'SWGreks';}\n\t.st4{fill:#E8501D;stroke:#BE1823;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st5{font-family:'MyriadPro-Regular';}\n\t.st6{font-size:23.9151px;}\n\t.st7{fill:none;stroke:#1E1E1C;stroke-miterlimit:10;}\n\t.st8{fill:#B2B2B2;}\n\t.st9{fill:#B2B2B2;stroke:#70706F;stroke-miterlimit:10;}\n\t.st10{fill:#FFFFFF;stroke:#70706F;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#70706F;stroke-miterlimit:10;}\n\t.st12{opacity:0.49;}\n\t.st13{fill:#FFFFFF;stroke:#1E1E1C;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#1E1E1C;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#1E1E1C;stroke-width:0.25;stroke-miterlimit:10;stroke-dasharray:5.9304,5.9304;}\n\t.st16{fill:none;stroke:#1E1E1C;stroke-width:0.25;stroke-miterlimit:10;stroke-dasharray:5.975,5.975;}\n\t.st17{fill:none;stroke:#1E1E1C;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st18{opacity:0.5;fill:#E95C0C;stroke:#E5352B;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st19{fill:none;stroke:#E8501D;stroke-miterlimit:10;}\n\t.st20{fill:none;stroke:#3D3D3B;stroke-width:2;stroke-miterlimit:10;}\n\t.st21{opacity:0.5;fill:#E8501D;stroke:#E5352B;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st22{fill:none;stroke:#1F71B8;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st23{fill:none;stroke:#1F71B8;stroke-width:0.25;stroke-miterlimit:10;stroke-dasharray:3.0307,3.0307;}\n\t.st24{fill:none;stroke:#1F71B8;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st25{fill:#1F71B8;}\n\t.st26{fill:none;stroke:#009640;stroke-miterlimit:10;}\n\t.st27{opacity:0.5;fill:#009640;stroke:#056734;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st28{font-size:44.8902px;}\n\t.st29{font-size:44.89px;}\n\t.st30{opacity:0.5;fill:#1F71B8;stroke:#2A3180;stroke-width:0.5;stroke-miterlimit:10;}\n")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 86.098297,
    y: 658.0954
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st0 st5 st6",
    x: 86.098297,
    y: 658.0954
  }, "- ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: "21.333px"
  }, "distance from the femur head centre ")), /*#__PURE__*/React.createElement("tspan", {
    className: "st0 st5 st6",
    x: 86.098297,
    y: 686.79541,
    fontSize: "21.333px"
  }, "   to a vertical through the larger trochanter"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st0 st1 st2",
    x: 50.974297,
    y: 655.5954,
    fontFamily: "BodoniMT-Italic",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Times New Roman'",
    fontStyle: "italic"
  }, "l"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st0 st3 st2",
    x: 40.446999,
    y: 786.35028
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 40.446999,
    y: 786.35028
  }, "\u03B2"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "st0 st3 st2",
    x: 40.448898,
    y: 725.22821
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 40.448898,
    y: 725.22821
  }, "\u03B1"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "st0 st1 st2",
    x: 44.784401,
    y: 587.45062
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Times New Roman'",
    fontStyle: "italic"
  }, "M"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m79.25 522.67c1.99-0.32 4.34-0.54 6.89-0.54 4.64 0 7.96 1.1 10.16 3.15 2.24 2.03 3.55 4.93 3.55 8.97 0 4.11-1.28 7.44-3.61 9.75-2.37 2.33-6.25 3.61-11.1 3.61-2.32 0-4.24-0.09-5.89-0.28zm3.25 22.18c0.82 0.13 2.02 0.15 3.26 0.15 6.94 0.02 10.68-3.85 10.68-10.63 0.04-5.92-3.31-9.66-10.14-9.66-1.68 0-2.93 0.16-3.8 0.33z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st0 st5 st6",
    transform: "translate(114.6 547.62)"
  }, "- ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: "21.333px"
  }, "weight lever arm")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 87.4338,
    y: 587.54602
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st0 st5 st6",
    x: 87.4338,
    y: 587.54602
  }, "- ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: "21.333px"
  }, "distance between centres of the ")), /*#__PURE__*/React.createElement("tspan", {
    className: "st0 st5 st6",
    x: 87.4338,
    y: 616.24597,
    fontSize: "21.333px"
  }, "   left and right femur heads"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "st0 st5 st6",
    x: 87.096397,
    y: 788.24091
  }, "- ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: "21.333px"
  }, "angle of the pelvis rotation, clockwise"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 86.096397,
    y: 723.44891
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st0 st5 st6",
    x: 86.096397,
    y: 723.44891
  }, "- ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: "21.333px"
  }, "angle of the abductors\u2019 line of action ")), /*#__PURE__*/React.createElement("tspan", {
    className: "st0 st5 st6",
    x: 86.096397,
    y: 752.14893,
    fontSize: "21.333px"
  }, "   with the vertical"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m196.85 247.66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m250.15 86.97-12.53 25.15-14.61 43.64 7.44 24.57 22.8 17.54 10.23 35.09 11.32 31.35 1.39 5.47 10.96 5.68 8.28 1.43 8.32-0.78 7.05-4.66 13.64-17.62 9.32-9.15 18.4-25.32 2.02-2.9 25.83-10.3 16.61-22-0.51-46.78-2.4-25.62-8.26 13.64-27.2 9.14-7.45 16.05s-9.05 2.46-11.12 3.11c-12.6 3.97-53.49-9.39-53.49-9.39s-6.96-1.66-8.4-4.34c-2.2-4.09-0.42-19.8-0.42-19.8l-24.48-16.43-2.74-16.77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m289.64 330.47c-2.22-0.03-4.88-0.28-7.7-0.77-2.15-0.37-4.16-0.84-5.93-1.36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m294.3 292.11c-2.22-0.03-4.88-0.28-7.7-0.77-2.15-0.37-4.16-0.84-5.93-1.36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m416.54 251.76s-36.23 20.99-50.31 30.43c-3.32 2.23-5.41 3.81-5.5 4.33-0.46 2.69-65.48 5.3-65.48 5.3l-6.65 38.51 16.21 12.94 28.16 39.91 37.19 3.65 94.97-117.35 52.61-53.64 16.55-53.15-65.57-74.3-74.07 17.65 1.32 12.54 2.18 20.61-0.68 46.66-12.54 16.48-2.97 3.9c5.06 2.72 17.54 15.94 17.54 15.94l-11.56 34.9-27.77 12.73 2.73 14.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m378.55 308.28 2.56 22.58-24.53 29.89s-37.95-25.92-37.49-28.61 1.27-12.69 2.32-13.43 24-16.15 24-16.15l33.14 5.72z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m181.07 211.74s27.09 31.92 37.19 45.53c2.38 3.21 3.82 5.41 3.73 5.92-0.46 2.69 59.91 26.94 59.91 26.94l-6.65 38.51-19.61 6.76-39.91 28.16-36.26-9.03-50.13-142.4-31.58-68.17 2.22-55.62 86.69-48.02 63.86 41.46-5.45 11.37-8.96 18.69-15.01 44.19 6.29 19.73 1.49 4.67c-5.68 0.86-21.87 9.14-21.87 9.14l-0.81 36.75 21.89 21.3-7.47 12.84"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m198.31 277.55-9.98 20.41 13.09 36.39s44.45-11.7 44.91-14.38c0.46-2.69 3.06-12.38 2.32-13.43s-17.2-23.26-17.2-23.26l-33.14-5.73z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "382.28 206.54 354.2 216.45 333.53 246.09 307.77 274.85"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "276.2 269.78 261.57 234.05 252.03 199.2 228.9 180.45"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m275.75 268.77c3.47 3.66 8.99 6.55 15.5 7.67 6.49 1.12 12.63 0.26 17.12-2.01"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "394.6 106.74 385.41 124.02 356.77 133.5 349.99 149.05"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m349.99 149.05c-0.89 5.15-17.59 6.57-37.31 3.17-19.71-3.4-34.97-10.34-34.09-15.49l-1.21-16.55-23.67-18.18-2.89-18.95"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m112.38 509.62-33.71-150.47-23.79-41.33 0.1-30.03 30.43-37.53 11.45 17.54 13.32 3.68 14.24-14.49c-0.19-1.53-0.29-3.09-0.29-4.67 0.07-19.72 16.11-35.65 35.83-35.58s35.65 16.11 35.58 35.83-16.11 35.65-35.83 35.58l-12.63 2.24-12.78 14.88-0.64 9.82-5.61 44.62 23.72 150.05"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 159.94,
    x2: 159.94,
    y1: -14.48,
    y2: -11.48
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 159.94,
    x2: 159.94,
    y1: -5.55,
    y2: 454.06
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 159.94,
    x2: 159.94,
    y1: 457.02,
    y2: 460.02
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "159.94 461.79 158.93 459.3 159.94 459.89 160.96 459.3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 9.57,
    x2: 12.57,
    y1: 252.13,
    y2: 252.13
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "18.55 252.13 487.99 252.13 541.37 252.13"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 544.35,
    x2: 547.35,
    y1: 252.13,
    y2: 252.13
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m548.86 252.13c-0.71 0.26-1.59 0.71-2.14 1.19l0.43-1.19-0.43-1.19c0.55 0.48 1.43 0.93 2.14 1.19z"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 286.65,
    x2: 286.19,
    y1: 435.87,
    y2: 252.13
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "292.2 431.64 286.65 434.01 281.09 431.67 286.67 444.82"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 271.51,
    y: 250.19,
    width: 14.84,
    height: 14.84
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 159.94,
    x2: 286.19,
    y1: 250.19,
    y2: 250.19
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st20",
    points: "189.2 256.69 159.08 251.28 423.9 298.81"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "m164.84 250.74 68.63-0.56s2.22 1.84 1.86 6.66c-0.29 3.92-2.78 6.76-2.78 6.76l-67.71-12.86z"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 86.49,
    x2: 87.3,
    y1: 250.71,
    y2: 249.44
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 88.91,
    x2: 237.06,
    y1: 246.88,
    y2: 12.45
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 237.86,
    x2: 238.67,
    y1: 11.17,
    y2: 9.9
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 169.62,
    x2: 86.42,
    y1: 118.55,
    y2: 249.54
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 169.62,
    x2: 92.1,
    y1: 118.55,
    y2: 240.6
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "86.42 249.54 89.27 233.67 92.52 239.93 99.57 240.21"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 160.71,
    x2: 107.22,
    y1: 252.13,
    y2: 214
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "126.74 227.49 107.87 214.52 120.41 194.91 139.28 207.88"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 85.93,
    x2: 161.22,
    y1: 251.2,
    y2: 251.2
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "st0 st1 st28",
    transform: "matrix(.9991 -.0427 .0427 .9991 110.93 302.57)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Times New Roman'",
    fontStyle: "italic"
  }, "l"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 169.62,
    cy: 118.55,
    r: 6.41
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "st0 st3 st29",
    transform: "translate(52.129 250.04)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u03B1"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "st0 st3 st29",
    transform: "translate(228.97 249.97)"
  }, /*#__PURE__*/React.createElement("tspan", null, "\u03B2"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "st0 st1 st29",
    transform: "translate(439.78 334.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Times New Roman'",
    fontStyle: "italic"
  }, "M"))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "m84.21 252.11h27s0.68-9-1.32-15c-2.11-6.32-8-14-8-14l-17.68 29z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFig2);
export default __webpack_public_path__ + "static/media/fig2.425d1ad4252c723a327ef1c0795cde42.svg";
export { ForwardRef as ReactComponent };